export default function (window, breakpoints) {
  const height = window.innerHeight;
  const width = window.innerWidth;

  let currentBreakpoint = 'small';

  const breakpointKeys = Object.keys(breakpoints);
  for (let i = 0; i < breakpointKeys.length; i += 1) {
    const breakpoint = breakpointKeys[i];

    if (breakpoints[breakpoint][0] > 0 && width < breakpoints[breakpoint][0]) {
      return currentBreakpoint;
    }

    if (breakpoints[breakpoint][1] > 0 && height < breakpoints[breakpoint][1]) {
      return currentBreakpoint;
    }

    currentBreakpoint = breakpoint;
  }

  return currentBreakpoint;
}
